import { render, staticRenderFns } from "./AlermHistory.vue?vue&type=template&id=4c1cfac2&scoped=true"
import script from "./AlermHistory.vue?vue&type=script&lang=js"
export * from "./AlermHistory.vue?vue&type=script&lang=js"
import style1 from "./AlermHistory.vue?vue&type=style&index=1&id=4c1cfac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cfac2",
  null
  
)

export default component.exports